import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { isRefiQualifiedWithAutoInsured } from '../../utils/app_data';

/** Asks income */
export const IncomeBeforeOnboardingStep: Step = {
  id: 'income',
  pathname: '/income',
  canShow: (appData: AppData) => {
    // If insurance is selected, ask income in the onboarding section if needed
    if (appData.selectedService?.insurance || appData.isFromMAL) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    // Only show when refi service is selected and user is qualified
    return !!appData.selectedService?.refi && isRefiQualifiedWithAutoInsured(appData);
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.PersonalInfo,
};
